
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-scholarship-test",
      function () {
        return require("private-next-pages/upsc-scholarship-test/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-scholarship-test"])
      });
    }
  